import React from 'react';

import { useTranslation } from 'react-i18next';

import Button from 'reactstrap/lib/Button';
import FormGroup from 'reactstrap/lib/FormGroup';
import Input from 'reactstrap/lib/Input';
import InputGroup from 'reactstrap/lib/InputGroup';
import InputGroupAddon from 'reactstrap/lib/InputGroupAddon';
import Label from 'reactstrap/lib/Label';

interface OwnProps {
  autoComplete?: string;
  className?: string;
  disabled?: boolean;
  id: string;
  label: string;
  name: string;
  placeholder?: string;
  type?:
    | 'text'
    | 'email'
    | 'select'
    | 'date'
    | 'datetime-local'
    | 'month'
    | 'number'
    | 'search'
    | 'tel'
    | 'url'
    | 'week'
    | 'password'
    | 'datetime'
    | 'time'
    | 'color';
  srOnlyLabel?: boolean;
  value: string | number;
  onChange: (newValue: string | number) => void;
}

type Props = Readonly<OwnProps>;

const FilterInput: React.FC<Props> = ({
  autoComplete,
  className,
  disabled,
  id,
  label,
  name,
  placeholder,
  srOnlyLabel,
  type,
  value,
  onChange,
  children,
}) => {
  const { t } = useTranslation();
  return (
    <FormGroup tag="fieldset" disabled={disabled} className={className}>
      <Label for={id} className={srOnlyLabel ? 'sr-only' : undefined}>
        {label}
      </Label>
      <InputGroup>
        <Input
          autoComplete={autoComplete}
          type={type}
          id={id}
          name={name}
          className="form-control"
          value={value}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
        >
          {children}
        </Input>
        {value !== '' && (
          <InputGroupAddon addonType="append">
            <Button color="secondary" onClick={(e) => onChange('')} title={t(`MASONRY.SEARCH.CLEAR`)}>
              <i className="fal fa-times" />
            </Button>
          </InputGroupAddon>
        )}
      </InputGroup>
    </FormGroup>
  );
};

export default React.memo(FilterInput);
